import api from './config';

// Get all gallery images (admin)
export const getGalleryImages = async (params = {}) => {
  try {
    const response = await api.get('/gallery', { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get active gallery images (public)
export const getActiveGalleryImages = async () => {
  try {
    const response = await api.get('/gallery/active');
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get single gallery image
export const getGalleryImage = async (id) => {
  try {
    const response = await api.get(`/gallery/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Create new gallery image
export const createGalleryImage = async (formData) => {
  try {
    const response = await api.post('/gallery', formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update gallery image
export const updateGalleryImage = async (id, formData) => {
  try {
    const response = await api.put(`/gallery/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Delete gallery image
export const deleteGalleryImage = async (id) => {
  try {
    const response = await api.delete(`/gallery/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Toggle gallery image active status
export const toggleGalleryImageStatus = async (id) => {
  try {
    const response = await api.patch(`/gallery/${id}/status`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get media by album
export const getMediaByAlbum = async (albumId) => {
  try {
    const response = await api.get(`/gallery/album/${albumId}`);
    // Process media URLs to ensure they're complete
    const processedData = response.data.map(item => {
      if (!item.imageUrl) return { ...item, imageUrl: null };
      
      const baseUrl = process.env.REACT_APP_API_URL || '';
      let imageUrl = item.imageUrl;
      
      if (!imageUrl.startsWith('http')) {
        // Ensure there's exactly one slash between base URL and image path
        imageUrl = `${baseUrl}${imageUrl.startsWith('/') ? '' : '/'}${imageUrl}`;
      }
      
      return {
        ...item,
        imageUrl
      };
    });
    return processedData;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Create new media
export const createMedia = async (formData) => {
  try {
    const response = await api.post('/gallery', formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
